import { render, staticRenderFns } from "./in-file.vue?vue&type=template&id=649148ce"
import script from "./in-file.vue?vue&type=script&lang=js"
export * from "./in-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports